let fetch
if (BROWSER) {
  fetch = window.fetch
} else {
  fetch = require('node-fetch')
  // Used by `@gymaholic/packages#fetchNetworkUtil`
  global.fetch = fetch
}

let agent
if (SERVER && DEVELOPMENT) {
  const https = require('https')
  agent = new https.Agent({
    rejectUnauthorized: false
  })
}

function timeout (timeoutMs, promise) {
  return new Promise((resolve, reject) => {
    const timerId = setTimeout(() => {
      reject(new Error('timeout'))
    }, timeoutMs)
    promise
      .then((res) => {
        clearTimeout(timerId)
        resolve(res)
      })
      .catch((res) => {
        clearTimeout(timerId)
        reject(res)
      })
  })
}

function fetchNetworkUtil (endpoint, options = {}, timeoutMs = 10000) {
  return timeout(
    timeoutMs, fetch(endpoint, {
      agent,
      ...options
    })
  )
}

export default fetchNetworkUtil
